import { useFormContext, useFormField } from '@calendly/form'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useEffect, useState } from 'react'

import { getDefaultIntervals } from 'components/availability/form/utils'
import { CustomHoursView } from 'components/event_type_edit'

import { ReadOnlyHoursView } from './read_only_hours_view'

export const IntervalsSection = ({ formPath, readOnly }) => {
  const { setFieldValue } = useFormContext()
  const [{ value: { availableHours: persistedAvailableHours } }] = useFormField({ name: formPath })

  const [availableHours, setAvailableHours] = useState(persistedAvailableHours)
  const [availableHoursCache, setAvailableHoursCache] = useState({})
  const isExtraSmallPhone = useDeviceType('isSmallPhone')

  useEffect(() => {
    setAvailableHours(persistedAvailableHours)
  }, [persistedAvailableHours, setAvailableHours])

  const onHoursUpdated = (day, intervals) => {
    const updatedHours = {
      ...availableHours,
      [day]: intervals
    }

    setAvailableHours(updatedHours)
    setFieldValue(`${formPath}.usingCustomHours`, true)
    setFieldValue(`${formPath}.usingSecondarySchedule`, false)
    setFieldValue(`${formPath}.availableHours`, updatedHours)
  }

  const addOrRemoveDay = (added, day) => {
    if (!added) {
      setAvailableHoursCache((cache) => ({
        ...cache,
        [day]: availableHours[day]
      }))
    }

    onHoursUpdated(day, added ? (availableHoursCache[day] || getDefaultIntervals()) : [])
  }

  return readOnly ? (
    <ReadOnlyHoursView
      days={availableHours}
      isExtraSmallPhone={isExtraSmallPhone}
    />
  ) : (
    <CustomHoursView
      days={availableHours}
      setWdayIntervals={onHoursUpdated}
      handleCheckboxClick={addOrRemoveDay}
      isExtraSmallPhone={isExtraSmallPhone}
      redesignStyling
      compact
    />
  )
}
